module.exports = __webpack_public_path__ + "static/media/logo.ec96fe06.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/createReactApp/logo.png
// module id = 52
// module chunks = 0